import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'banner-forgot-details',
  templateUrl: './banner-forgot-details.component.html',
  styleUrls: ['./banner-forgot-details.component.scss']
})
export class BannerForgotDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
